/** برند — لوگو در public/logo.png */
export const COMPANY_NAME = 'شرکت توسعه زیرساخت خوارزمی';
export const COMPANY_TAGLINE = 'سیستم آنالیز بها';
export const APP_TITLE = COMPANY_TAGLINE;
export const LOGO_SRC = '/logo.png';

/** شعار اصلی شرکت */
export const COMPANY_SLOGAN = 'زیرساخت دقیق، تصمیم هوشمند';

/** شعارهای چرخشی هنگام بارگذاری — مرتبط با آنالیز بها و مناقصه */
export const LOADING_SLOGANS = [
  'زیرساخت دقیق، تصمیم هوشمند',
  'از برآورد تا برنده — با خوارزمی',
  'محاسبه شفاف، مناقصه مطمئن',
  'خوارزمی؛ پایه محکم پروژه‌های ملی',
  'آنالیز بها · تعیین دامنه · بررسی هوشمند',
  'دقت در عدد، اطمینان در تصمیم',
  'توسعه زیرساخت با نگاه مهندسی و اقتصاد',
] as const;
